@if (expandMenuDrawer$ | async) {}
<ng-container *ngIf="gridView$ | async as view">
  <div class="st-top-bar flex justify-content-between">
    @if (view === "medium" || view === "small") {
      <div class="show-hide-toggle">
        <button
          type="button"
          [ngClass]="{ active: this.isExpand() }"
          (click)="expandDrawer()"
        >
          <em class="ph ph-sidebar"></em>
        </button>
      </div>
    }
    <div
      class="st-top-bar-content flex-1 flex align-items-center justify-content-between ml-auto"
    >
      @if (view !== "medium" && view !== "small") {
        <div class="align-self-end flex-1">
          <z-top-header-tabs />
        </div>
      } @else {
        <z-mobile-page-title />
      }
      <z-top-header-right-section>
        <div ngProjectAs="notification-section">
          <ng-content select="top-header-notification-section" />
        </div>
        <div ngProjectAs="top-filters-section">
          <ng-content select="top-header-filters-section" />
        </div>
      </z-top-header-right-section>
    </div>
  </div>
</ng-container>
